/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceIpadHorizontal = createReactComponent("outline", "device-ipad-horizontal", "IconDeviceIpadHorizontal", [["path", { "d": "M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M9 17h6", "key": "svg-1" }]]);

export { IconDeviceIpadHorizontal as default };
//# sourceMappingURL=IconDeviceIpadHorizontal.mjs.map
